import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import css from './ForBusinessComponents.module.css';
import classNames from 'classnames';

const comparisonData = {
  features: {
    builtForDiscovery: '🎯 Built for discovery',
    soloFriendly: '🤝 Designed for everyone',
    openCrm: '🔓 Open to any CRM',
    sessionListing: '📣 Every gym, club, class, & trainer has their own listing',
    pricing: '💷 Simple, low-cost pricing',
    onboarding: '💻 No setup or tech onboarding',
    localVisibility: '📍 Local-first visibility',
    noLockIn: '🔁 No lock-in or contracts',
    freeMarketing: '📸 Free marketing perks (launch only)',
  },
  labels: {
    footfall: 'FootFall',
    mindbody: 'Mindbody',
    classpass: 'ClassPass',
  },
  footfall: {
    builtForDiscovery: { icon: '✅', description: '' },
    openCrm: { icon: '✅', description: '' },
    sessionListing: { icon: '✅', description: '' },
    pricing: { icon: '✅', description: '' },
    onboarding: { icon: '✅', description: '' },
    localVisibility: { icon: '✅', description: '' },
    noLockIn: { icon: '✅', description: '' },
    freeMarketing: { icon: '✅', description: '' },
    soloFriendly: { icon: '✅', description: '' },
  },
  mindbody: {
    builtForDiscovery: { icon: '❌', description: 'No – booking first' },
    openCrm: { icon: '❌', description: 'Requires full CRM' },
    sessionListing: { icon: '❌', description: 'Only main brand page' },
    pricing: { icon: '❌', description: '£200+/month avg.' },
    onboarding: { icon: '❌', description: 'Onboarding required' },
    localVisibility: { icon: '❌', description: 'Global platform' },
    noLockIn: { icon: '❌', description: 'Annual contracts' },
    freeMarketing: { icon: '❌', description: 'None' },
    soloFriendly: { icon: '❌', description: 'Geared to large gyms' },
  },
  classpass: {
    builtForDiscovery: { icon: '⚠️', description: 'Partly – only classes' },
    openCrm: { icon: '❌', description: 'Closed ecosystem' },
    sessionListing: { icon: '❌', description: 'ClassPass optimised for classes' },
    pricing: { icon: '❌', description: 'Commission-based' },
    onboarding: { icon: '❌', description: 'Structured rollout' },
    localVisibility: { icon: '❌', description: 'City-wide targeting' },
    noLockIn: { icon: '❌', description: 'Partnership model' },
    freeMarketing: { icon: '❌', description: 'None' },
    soloFriendly: { icon: '❌', description: 'Prioritises volume' },
  },
};

export const CompetitorComparisonTable = () => {
  const platforms = Object.keys(comparisonData).filter(
    key => key !== 'features' && key !== 'labels'
  );

  return (
    <div className={css.competitorComparisonTableContainer}>
      <div className={css.tableScrollWrapper}>
        <TableContainer>
          <Table size="small" className={css.competitorComparisonTable}>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Feature</strong>
                </TableCell>
                {platforms.map(platform => (
                  <TableCell key={platform} component="th" scope="row" align="center">
                    <strong>{comparisonData.labels[platform] || platform}</strong>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.entries(comparisonData.features).map(([key, label]) => (
                <TableRow key={key}>
                  <TableCell>
                    <strong>{label}</strong>
                  </TableCell>
                  {platforms.map(platform => {
                    const { icon, description } = comparisonData[platform][key] || {};
                    return (
                      <TableCell
                        key={platform + key}
                        align="center"
                        className={classNames({
                          [css.cellSuccess]: icon === '✅',
                          [css.cellError]: icon === '❌',
                          [css.cellWarning]: icon === '⚠️',
                        })}
                      >
                        <div>{icon}</div>
                        {description && <small>{description}</small>}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};
